import { useMutation, useQueryClient } from "@tanstack/react-query";
import adminApiClient, { FaqItem } from "api/admin";
import { STUDIO_FAQ_QUERY_KEY } from "./useStudioFaq";

const useSaveStudioFaq = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (items: FaqItem[]) => adminApiClient.saveStudioFaq(items),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [STUDIO_FAQ_QUERY_KEY] });
    },
  });
};

export default useSaveStudioFaq;
